import * as _ from "lodash";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import StateProvince from "domain/stateProvince";
import { StateProvincesLoaded } from "./geo.actions";

export class StateProvinceReducer extends ReducerBase<StateProvince[]> {
  constructor() {
    super();
    this.addHandler(StateProvincesLoaded.EventName, this.handleStateProvincesLoaded);
  }

  handleStateProvincesLoaded(
    state: StateProvince[] = initialState.stateProvinces,
    event: StateProvincesLoaded
  ): StateProvince[] {
    return event.states;
  }

  handleDefault(state: StateProvince[] = initialState.stateProvinces) {
    return state;
  }
}
